module.exports = __webpack_public_path__ + "img/c5.e5953b87.png";